import { useEffect } from "react";
import "../styles/Slideout.css";
import { useSlideout } from "../hooks/SlideoutContext";
import { FaX } from "react-icons/fa6";

const Slideout = ({ isOpen, isExpanded, onClose, title, content }) => {
  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "auto";
    return () => (document.body.style.overflow = "auto");
  }, [isOpen]);

  return (
    <div className={`slideout-overlay ${isOpen ? "open" : ""}`} onClick={onClose}>
      <div className={`slideout-panel ${isExpanded ? "expanded" : ""}`} onClick={(e) => e.stopPropagation()}>
        <div className="SlideoutHeader">
            <div className="SlideoutHeaderTitle">{title}</div>
            <div className="SlideoutHeaderClose" onClick={onClose}><FaX size={14} color="#2c2c2c"/></div>
        </div>
        {content}
      </div>
    </div>
  );
};

export default Slideout;
